import { Input, Label } from "reactstrap";

const RecentTradingActivitiesHeader = () => {
  return (
    <thead>
      <tr>
        <th>
          <div className="form-check">
            <Input type="checkbox" />
            <Label className="form-check-label" />
          </div>
        </th>
        <th>Name and type</th>
        <th>Customer</th>
        <th>ID and Status</th>
        <th>Volume</th>
      </tr>
    </thead>
  );
};

export default RecentTradingActivitiesHeader;
